/*
 * COPYRIGHT: EUMETSAT 2018
 * LICENSE: PROPRIETARY
 * PROJECT: WMS
 * 
 * All information contained herein is, and remains the property of EUMETSAT.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * EUMETSAT.
 */

import { Component, Input, Output, EventEmitter } from '@angular/core';

import { ToastService } from './toast.service';

@Component({
    selector: 'toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss']
})
export class ToastComponent {

    constructor(public toastService: ToastService) {

    }

}



// WEBPACK FOOTER //
// ./src/layout/toast/toast.component.ts